export const verification_response = {
    passport_doc:{
        FILE_NUMBER: "special_notes",
        DOCUMENT_NUMBER: "document_number",
        NAME: "surname_and_given_names",
        VERIFIED: "is_verify"
    },
    pan_card:{
        NAME: "surname_and_given_names",
        DOB:"date_of_birth",
        VERIFIED:"is_verify"
    },
    tin_card:{
        NAME: "surname_and_given_names",
        DOB:"date_of_birth",
        VERIFIED:"is_verify"
    },
    driving_licence_doc:{
        DOCUMENT_NUMBER: "document_number",
        NAME: "surname_and_given_names",
        APPLICANT: "name",
        EXPIRY_DATE: "date_of_expiry",
        DATE_OF_EXPIRY: "doe",
        VERIFIED: "is_verify",
    }
}